<template>
  <div class="max-w-2xl mx-auto py-8">
    <UsageLogForm @save="handleSave" @cancel="handleCancel" />
    <div v-if="success" class="mt-6 p-4 bg-green-50 border border-green-200 rounded text-green-800">
      Usage log created successfully.
    </div>
    <div v-if="error" class="mt-6 p-4 bg-red-50 border border-red-200 rounded text-red-800">
      {{ error }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useUsageStore } from '@/stores/usageStore'
import type { UsageLogCreate } from '@/types/usage'
import UsageLogForm from '@/components/usage/UsageLogForm.vue'
import { useRouter } from 'vue-router'

const usageStore = useUsageStore()
const loading = ref(false)
const success = ref(false)
const error = ref('')
const router = useRouter()

const handleSave = async (data: UsageLogCreate) => {
  loading.value = true
  error.value = ''
  success.value = false
  try {
    await usageStore.createUsageLog(data)
    success.value = true
    setTimeout(() => {
      router.push({ name: 'UsageView' })
    }, 1200)
  } catch (err: unknown) {
    const e = err as unknown as Error
    error.value = e?.message || 'Failed to create usage log.'
  } finally {
    loading.value = false
  }
}

const handleCancel = () => {
  router.push({ name: 'UsageView' })
}
</script>
